import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as Styled from './VideoPreview.styled';
import { vhFilePropTypes } from '../../../proptypes/Actions';
import PreviewModal from '../PreviewModal/PreviewModal';
import OpenMediaModalButton from '../../atoms/OpenMediaModalButton/OpenMediaModalButton';
import WrapMediaPreview from '../../atoms/WrapMediaPreview/WrapMediaPreview';

const VideoPreview = (props) => {
  const innerVideoRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // pause video when closing dialog
  useEffect(() => {
    if (!visible && innerVideoRef.current) {
      innerVideoRef.current.pause();
    }
  }, [visible]);

  const handleOpen = useCallback(() => {
    setVisible(true);
  }, []);
  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <>
      <WrapMediaPreview>
        <OpenMediaModalButton onClick={handleOpen} />
        <Styled.PreviewVideo
          preload="metadata"
          crossOrigin="anonymous"
          src={props.file.url}
          controls={false}
          type={props.file.type}
          disablePictureInPicture={true}
        />
        <Styled.CenteredMediaPreviewIcon />
      </WrapMediaPreview>
      <PreviewModal mediaPreview={true} show={visible} onHide={handleClose}>
        <Styled.ModalBackground>
          <Styled.OpenedVideo
            ref={innerVideoRef}
            preload="metadata"
            crossOrigin="anonymous"
            controls={true}
            src={props.file.url}
            type={props.file.type}
            disablePictureInPicture={true}
          />
        </Styled.ModalBackground>
      </PreviewModal>
    </>
  );
};

VideoPreview.propTypes = {
  file: vhFilePropTypes,
};

export default VideoPreview;
